import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { VolunteerOrganizationLead } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrganizationLead>();

export class VolunteerOrganizationLeadFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrganizationLead>
  >((filters) =>
    filterWithRelationsAndJson(VolunteerOrganizationLead)(filters),
  );
}
